import React, { useRef } from "react";
import { useState, useEffect } from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import "./procedimentosPlanosCadastros.css";
import Header from "../../components/header/header";
import CustomModal from "../../components/modal/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSave, faWindowClose } from "@fortawesome/free-solid-svg-icons";
import {
  getProcedimentoPlanosUpdate,
  getProcedimentoPlanosCadastro,
  getProcedimentosPlanosById,
} from "../../services/api_cadastro_procedimento_plano";
import { getServicos } from "../../services/api_servicos";
import Swal from "sweetalert2";
import Spinner from "react-bootstrap/Spinner";
import { getPlanosManutencao } from "../../services/api_planos_manutencao";
import { getSetoresExecutantes } from "../../services/api_setores_executantes";
import POLLING_INTERVAL from "../../hooks/Interval/interval";

const ProcedimentosPlanosRegister = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const id = location.state?.id;
  const idPlano = location.state?.idPlano;
  const nomePlano = location.state?.nomePlano;
  //console.log(idPlano);
  //console.log(nomePlano);

  const [descricao, setDescricao] = useState("");
  const [tempo_estimado, setTempoEstimado] = useState("");
  const [id_servico, setServico] = useState("");
  const [id_setor_executante, setSetoresExecutantes] = useState("");
  const [servicos, setServicos] = useState([]);
  const [planos_manutencao, setPlanosManutencao] = useState([]);
  const [setor_executante, setSetorExecutante] = useState([]);

  const [isLoading, setLoading] = useState(true);
  const [isSaving, setSaving] = useState(false)

  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState({});

  const inputRefs = {
    Descricao: useRef(null),
    tempoEstimado: useRef(null),
    Servicos: useRef(null),
    setorExecutante: useRef(null)
  };

  useEffect(() => {
    const fetchProcedimentosPlanos = async () => {
      try {
        const response = await getProcedimentosPlanosById(id);
        //console.log(response);
        const procedimentos_planos = response.data.registro; // Corrigido para acessar response.data.empresa
        if (procedimentos_planos) {
          setDescricao(procedimentos_planos.descricao || "");
          setTempoEstimado(
            formatarTempo(procedimentos_planos.tempo_estimado) || ""
          );
          setServico(procedimentos_planos.id_servico || "");
          setSetoresExecutantes(procedimentos_planos.id_setor_executante || "");
        } else {
          console.error("Dados não encontrados na resposta:", response);
        }
      } catch (error) {
        console.error("Erro ao obter dados da unidade:", error);
      }
    };

    if (id) {
      fetchProcedimentosPlanos();
    }
  }, [id]);

  const formatarTempo = (tempo) => {
    if (tempo) {
      // Extrair horas e minutos do tempo
      const [horas, minutos] = tempo.split(":");
      // Formatar para duas casas decimais
      return `${horas.padStart(2, "0")}:${minutos.padStart(2, "0")}`;
    }
    return tempo;
  };

  useEffect(() => {
    const fetchServicos = async () => {
      try {
        const response = await getServicos();
        //console.log(response);

        if (response) {
          const servicosAtivos = response.data.Servicos.filter(
            (servico)=> servico.deleted_at === null
          )
          setServicos(servicosAtivos);
          setLoading(false);
        } else {
          console.error("Algo deu errado:");
        }
        //console.log(response);
      } catch (error) {
        console.error("Erro ao obter empresas:", error);
      }
    };

    fetchServicos();
    const interval = setInterval(()=>{
      fetchServicos()
    }, POLLING_INTERVAL);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const fetchPlanosManutencao = async () => {
      try {
        const response = await getPlanosManutencao();
        //console.log(response);

        if (response) {
          setPlanosManutencao(response.data.PlanosManutencao);
          setLoading(false);
        } else {
          console.error("Algo deu errado:");
        }
        //console.log(response);
      } catch (error) {
        console.error("Erro ao obter empresas:", error);
      }
    };

    fetchPlanosManutencao();
    const interval = setInterval(()=>{
      fetchPlanosManutencao()
    }, POLLING_INTERVAL);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const fetchSetorExecutante = async () => {
      try {
        const response = await getSetoresExecutantes();
        //console.log(response);

        if (response) {
          const setorAtivo = response.data.SetoresExecutantes.filter(
            (setor)=> setor.deleted_at === null
          )
          setSetorExecutante(setorAtivo);
          setLoading(false);
        } else {
          console.error("Algo deu errado:");
        }
        //console.log(response);
      } catch (error) {
        console.error("Erro ao obter setor executante:", error);
      }
    };

    fetchSetorExecutante();
    const interval = setInterval(()=>{
      fetchSetorExecutante()
    }, POLLING_INTERVAL);
    return () => clearInterval(interval);
  }, []);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleOpenModal = (title, body) => {
    setModalContent({ title, body });
    setShowModal(true);
  };

  const handleDataHora = (e) => {
    if (!e) {
      return;
    }
    // Extrair apenas horas e minutos
    const [horas, minutos] = e.split(":");
    return `${horas}:${minutos}`;
  };
  

  const validarInputs = () => {
    if (!descricao || !id_servico || !id_setor_executante) {
      Swal.fire({
        icon: "warning",
        title: "Oops!",
        text: "O preenchimento dos campos Descrição, Serviço e Setor Executante é obrigatório.",
      });

      return false;
    }
    return true;
  };

  const addCadastro = async (body) => {
    try {
      const response = await getProcedimentoPlanosCadastro(body);

      if (response && response.status === 200) {
        regret();
      } else {
        console.error("Erro ao cadastrar unidade:", response);
      }
    } catch (error) {
      console.error("Erro ao cadastrar unidade:", error);
    }finally {
      setSaving(false); // Desativa o spinner após o salvamento
    }
  };

  const newUpdate = async (body) => {
    try {
      const response = await getProcedimentoPlanosUpdate(id, body);

      if (response && response.status === 200) {
        regret();
      } else {
        console.error("Erro ao cadastrar unidade:", response);
      }
    } catch (error) {
      if (error.response && error.response.status === 422) {
        handleOpenModal(
          "Erro de validação",
          "Houve um erro na validação dos dados."
        );
      } else if (error.response && error.response.status === 500) {
        handleOpenModal(
          "Erro interno do servidor",
          "Ocorreu um erro interno no servidor. Por favor, tente novamente mais tarde."
        );
      } else {
        console.error("Erro ao atualizar a empresa:", error);
        handleOpenModal(
          "Erro ao atualizar a empresa",
          "Por favor, tente novamente mais tarde."
        ); // Exibir mensagem genérica de erro
      }
    }finally {
      setSaving(false); // Desativa o spinner após o salvamento
    }
  };

  const handleSalvar = () => {
    if (validarInputs()) {
      setSaving(true)
      let body = {
        descricao,
        tempo_estimado: handleDataHora(tempo_estimado),
        id_servico,
        id_setor_executante,
        id_plano_manutencao: idPlano,
      };

      if (id) {
        newUpdate(body);
      } else {
        addCadastro(body);
      }
    }
  };

  const handleCaracteres = (e) => {
    const value = e.target.value;
    if (value.length <= 50) {
      setDescricao(value);
    } else {
      Swal.fire({
        icon: "warning",
        title: "Oops!",
        text: "O campo Descrição não pode ultrapassar 50 caracteres",
      });
    }
  };

  const handleKeyDown = (e, nextFieldRef) => {
    if (e.key === 'Enter' && nextFieldRef.current) {
      e.preventDefault();
      const elementToFocus = nextFieldRef.current.inputRef || nextFieldRef.current;
  
      if (typeof elementToFocus.focus === 'function') {
        elementToFocus.focus();
      } else {
        console.warn('O elemento de input não tem o método focus.');
      }
    }
  };
  

  const regret = () => {
    window.history.back();
  };

  return (
    <>
      <Header title="Cadastros / Cadastro de Procedimentos de Plano" />
      <div className="content-wrapper pl-5 pr-5 pt-2">
        {isLoading ? (
          <div className="center-btn">
            <h5 className="mb-5">Carregando dados</h5>
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        ) : (
          <Form>
            <Row>
              <Col md={3} className="mb-3">
                <Form.Group controlId="formDescricao">
                  <Form.Label>Descrição</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Digite a Descrição"
                    value={descricao}
                    onChange={handleCaracteres}
                    ref={inputRefs.Descricao}
                    onKeyDown={(e) => handleKeyDown(e, inputRefs.Servicos)}
                  />
                </Form.Group>
              </Col>
              <Col md={3} className="mb-3">
                <Form.Group controlId="formUniMedida">
                  <Form.Label>Serviços</Form.Label>
                  <Form.Control
                    as="select"
                    value={id_servico}
                    onChange={(e) => setServico(e.target.value)}
                    ref={inputRefs.Servicos}
                    onKeyDown={(e) => handleKeyDown(e, inputRefs.tempoEstimado)}
                  >
                    <option value="">Selecione</option>
                    {servicos &&
                      servicos.map((id_servico) => (
                        <option key={id_servico.id} value={id_servico.id}>
                          {id_servico.descricao}
                        </option>
                      ))}
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col md={3} className="mb-3">
                <Form.Group controlId="formModelo">
                  <Form.Label>Tempo Estimado</Form.Label>
                  <Form.Control
                    type="time"
                    placeholder="hh:mm"
                    value={tempo_estimado}
                    onChange={(e) => setTempoEstimado(e.target.value)}
                    ref={inputRefs.tempoEstimado}
                    onKeyDown={(e) => handleKeyDown(e, inputRefs.setorExecutante)}
                  />
                </Form.Group>
              </Col>
              <Col md={3} className="mb-3">
                <Form.Group controlId="formSetorExecutante">
                  <Form.Label>Setor Executante</Form.Label>
                  <Form.Control
                    as="select"
                    value={id_setor_executante}
                    onChange={(e) => setSetoresExecutantes(e.target.value)}
                    ref={inputRefs.setorExecutante}
                  >
                    <option value="">Selecione</option>
                    {setor_executante &&
                      setor_executante.map((id_setor_executante) => (
                        <option
                          key={id_setor_executante.id}
                          value={id_setor_executante.id}
                        >
                          {id_setor_executante.descricao}
                        </option>
                      ))}
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>

            <div className="center-two-btn d-flex justify-content-center ">
              <Button
                className="border border-dark text-dark m-2 mt-4"
                variant="light"
                onClick={handleSalvar}
                disabled = {isSaving}
              >
                {isSaving ? (
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                ) : (
                  <FontAwesomeIcon icon={faSave} />
                )}
              </Button>
              <Button
                className="border border-dark text-dark m-2 mt-4"
                variant="light"
                onClick={regret}
              >
                <FontAwesomeIcon icon={faWindowClose} />
              </Button>
            </div>
          </Form>
        )}
      </div>

      <CustomModal
        show={showModal}
        handleClose={handleCloseModal}
        title={modalContent.title}
        body={modalContent.body}
      />
    </>
  );
};

export default ProcedimentosPlanosRegister;
